import Menu from '@mui/material/Menu';
import { MapContextMenuProps } from './types';
import MenuItem from '@mui/material/MenuItem';
import { useContext } from 'react';
import { MapContext } from 'components/maps/MapContext';
import { Divider } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const MapContextMenu: React.FC<MapContextMenuProps> = ({
  items,
  position,
  handleClose,
  coordinates,
}) => {
  const { t } = useTranslation(['app']);
  const { selectedEntities, removeAllEntities, additionalMapContextMenuItems } =
    useContext(MapContext);

  return (
    <Menu
      id='map-context-menu'
      anchorReference='anchorPosition'
      anchorPosition={position}
      open={!!position}
      onClose={handleClose}
      onContextMenu={(e) => {
        // sometimes right clicks on the map will fire on this element as it opens.
        e.preventDefault();
      }}
    >
      {items.map((item, pos) => (
        <MenuItem
          key={`MapContextMenuItem_${pos}`}
          onClick={() => {
            handleClose();
            item.callback(coordinates ? { coordinates } : null);
          }}
        >
          {item.text}
        </MenuItem>
      ))}
      {additionalMapContextMenuItems.length > 0 || selectedEntities.size > 0 ? <Divider /> : null}
      {additionalMapContextMenuItems.length > 0
        ? additionalMapContextMenuItems.map((item, index) => (
            <MenuItem
              key={`AdditionalMapContextMenuItem_${index}`}
              onClick={() => {
                item.callback(coordinates ? { coordinates } : null);
                handleClose();
              }}
            >
              {item.text}
            </MenuItem>
          ))
        : null}
      {selectedEntities.size > 0 && (
        <MenuItem
          onClick={() => {
            removeAllEntities();
            handleClose();
          }}
        >
          {t('removeAllSelections')}
        </MenuItem>
      )}
    </Menu>
  );
};
